<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">材料分类</div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :not-operate="true" :menu-data="classifyList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-f5971d"></span>
            {{currentClassify.name}}
          </div>
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData" @change-current-row="changeCurrentRow"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
      <move-vertical :max="560" :min="150" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 220px">
        <div class="flex mb-10" style="border-bottom:1px solid #e2e2e2; padding-bottom: 5px;">
          <div class="smallTitle">
            <span class="bg-4-f5971d" style="margin-left: 0;"></span>
            材料库存量
          </div>
        </div>
        <div class="mb-10 flex align-center" v-if="startList.length == 0">
          <div class="flex align-center mr-5 mb-5" @click="addInventory" :class="isHover ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter" @mouseleave="leave">
            <img :src="isHover ? btn.iconActive : btn.icon" class="icon-14 mr-5" alt="">
            <div>{{btn.name}}</div>
          </div>
        </div>
        <div class="flex-1 h-0" style="width: 99.9%;">
          <erp-table :is-edit="true" class="grayTable" ref="erpTable2" :table-data="inventoryData" :loading="loading2" :column-data="columnData2" @on-select="onSelect" @on-delete="onDelete" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
        </div>
      </div>
    </div>
    <el-dialog title="选择仓库" :visible.sync="selectVisible" width="30%">
      <div class="flex align-center mb-10 p-20">
        <div class="font-12-30313a mr-5">分类名称：</div>
        <el-select v-model="storehouseValue" placeholder="请选择仓库" class="flex-1">
          <el-option v-for="(item, index) in storehouseList"  :key="item.id" :label="item.name" :value="index">
          </el-option>
        </el-select>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="closeSelect">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitSelect">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'startInventoryDefine',
  components: {Pagination, MoveHorizon, MoveVertical, CateMenu, ErpTable},
  data () {
    return {
      page: 1,
      limit: 10,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      classifyList: [],
      chooseMenuId: 0,
      currentClassify: {},
      loading: false,
      tableData: [],
      columnData: [{
        field: 'name',
        title: '材料名称',
        nimWidth: '100'
      }, {
        field: 'code',
        title: '材料编码',
        nimWidth: '100'
      }, {
        field: 'standard',
        title: '规格',
        nimWidth: '80'
      }, {
        field: 'model',
        title: '型号',
        nimWidth: '80'
      }, {
        field: 'salesUnit',
        title: '单位',
        nimWidth: '100'
      }, {
        field: 'startingQuantity',
        title: '数量',
        nimWidth: '100'
      }, {
        field: 'costPrice',
        title: '成本价',
        nimWidth: '100'
      }, {
        field: 'total',
        title: '金额',
        nimWidth: '100'
      }],
      btn: {
        name: '新增',
        label: 'addReceipt',
        icon: '/static/images/add.png',
        iconActive: '/static/images/add-bai.png'
      },
      isHover: false,
      loading2: false,
      columnData2: [{
        field: 'operate',
        title: '操作',
        width: '140',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '删除',
          methodName: 'on-delete',
          type: 'btn'
        }, {
          className: 'btn-16-bg-85 btn-hover mr-5',
          title: '选择仓库',
          methodName: 'on-select',
          type: 'btn'
        }]
      }, {
        field: 'storehouseName',
        title: '仓库名称',
        nimWidth: '100'
      }, {
        field: 'quantity',
        title: '库存量',
        nimWidth: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'description',
        title: '说明',
        nimWidth: '80',
        editRender: {
          name: 'input'
        }
      }],
      inventoryData: [],
      currentRow: null,
      selectVisible: false,
      storehouseList: [],
      storehouseValue: null,
      currentInventory: null,
      startList: [],
      inventoryShow: null
    }
  },
  created () {
  },
  mounted () {
    this.getClassify()
    this.getStorehouse()
    this.getStart()
  },
  methods: {
    getStart () {
      this.axios.post('inventoryPeriod/list', {companyId: this.$store.state.companyId, status: 2}).then(res => {
        if (res.data.success) {
          this.startList = res.data.data
        }
      })
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 0
        this.getMaterial()
      }
    },
    getMaterial () {
      this.tableData = []
      let params = {
        classifyId: this.chooseMenuId,
        page: this.page,
        limit: this.limit,
        startInventoryFlag: 1
      }
      this.axios.post(`material/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (this.tableData.length > 0) {
            this.currentRow = this.tableData[0]
            this.$nextTick(() => {
              this.getInventoryData()
            })
          }
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`materialClassify/findAllClassify`, {companyId: this.$store.state.companyId, inventoryFlag: 1}).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getMaterial()
      }
    },
    getStorehouse () {
      this.axios.post(`storehouse/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.storehouseList = res.data.data
        }
      })
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.$nextTick(() => {
        this.getInventoryData()
      })
    },
    getInventoryData () {
      this.axios.post(`materialBeginningStock/list`, {
        materialId: this.currentRow.id
      }).then(res => {
        if (res.data.success) {
          this.inventoryData = []
          res.data.data.forEach(i => {
            i.unEditable = 'storehouseName'
            this.inventoryData.push(i)
          })
        }
      })
    },
    addInventory () {
      this.selectVisible = true
      this.inventoryShow = 1
    },
    onSelect (row) {
      this.currentInventory = row
      this.storehouseValue = null
      this.storehouseList.forEach((item, index) => {
        if (item.id === row.storehouseId) {
          this.storehouseValue = index
        }
      })
      this.$nextTick(() => {
        this.selectVisible = true
        this.inventoryShow = 0
      })
    },
    submitSelect () {
      if (this.storehouseValue == null || !this.storehouseList[this.storehouseValue].name) {
        this.$message.warning('请选择仓库')
      } else {
        if (this.inventoryShow === 1) {
          let params = {
            companyId: this.$store.state.companyId,
            materialId: this.currentRow.id,
            quantity: null,
            storehouseId: this.storehouseList[this.storehouseValue].id,
            storehouseName: this.storehouseList[this.storehouseValue].name,
            description: ''
          }
          this.axios.post('materialBeginningStock/save', params).then(res => {
            if (res.data.success) {
              // this.$refs.erpTable2.insertAt(res.data.data, this.inventoryData[0])
              // this.total++
              this.getInventoryData()
              this.closeSelect()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        } else {
          let params = {
            id: this.currentInventory.id,
            storehouseId: this.storehouseList[this.storehouseValue].id,
            storehouseName: this.storehouseList[this.storehouseValue].name,
            companyId: this.$store.state.companyId
          }
          this.axios.post('materialBeginningStock/modify', params).then(res => {
            if (res.data.success) {
              this.$message.success('修改成功')
              this.getInventoryData(false)
              this.closeSelect()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }
      }
    },
    onModifyRow (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName],
        companyId: this.$store.state.companyId
      }
      this.axios.post('materialBeginningStock/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getInventoryData(false)
          this.getMaterial()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    closeSelect () {
      this.selectVisible = false
      this.storehouseValue = null
    },
    onDelete (row) {
      const that = this
      this.$confirm(`此操作将删除"${row.storehouseName}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('materialBeginningStock/deleteById', that.qs.stringify({id: row.id})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            that.getInventoryData()
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    enter () {
      this.isHover = true
    },
    leave () {
      this.isHover = false
    },
    jump (page) {
      this.page = page
      this.getMaterial()
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  .el-icon-zoom-in {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #30313a;
  }
  .font-13-f5971d {
    font-size: 13px;
    color: #f5971d;
  }
  .smallTitle {
    font-size: 16px;
    color: #f5971d;
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;
    position: relative;
    span {
      height: 16px;
    }
  }
  .smallTitle:after{
    display: block;
    content: '';
    width: 100%;
    height: 1px;
    background: #f5971d;
    position: absolute;
    bottom: -6px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/startInventoryDefine.vue